import SphTabs from './Tabs.vue';

export type { Tab, Tabs, TabsSize } from './types';

export { SphTabs };
export default SphTabs;
